export default __webpack_public_path__ + "media/images/CooksLogo-58095162706169194317d0fae815d78f.svg";